import { ConsiderationGroupEnum, ProtocolListAssignment } from '@app/advisor-shared';
export const DDX_HOVER_MS = 400;
export const resolveDdxHoverConsideration = (listAssignment, consideration) => {
    if (listAssignment === ProtocolListAssignment.CONSIDER_NOW)
        return 'high';
    if (listAssignment === ProtocolListAssignment.CONSIDER_LATER)
        return 'low';
    return consideration === ConsiderationGroupEnum.HIGH_CONSIDERATION ? 'high' : 'low';
};
//# sourceMappingURL=resolve-ddx-hover.js.map